import React from 'react';
import Grid from '@mui/material/Grid';
import VoteCard from '@/components/job-title/vote-card';
import CityCard, { HotCitiesType } from '@/components/city/CityCard';
import { Post, PostType } from '@/components/home-page/RecommendPost';
import JobOpportunityPanel, {
  JobOpportunityType,
} from '@/components/job-opportunity-panel';

const RenderTabs = React.memo(
  ({
    content,
    recommendedJobOpportunities,
    recommendPost,
    showLeft = true,
    showVoteCard = false,
    showLocation = false,
    locationSalary,
    rate = null,
    marketingEle = <></>,
    marginTop = 'tablet:mt-29',
  }: {
    content: {
      id: string;
      key: string;
      name?: string;
      node?: React.ReactNode;
    }[];
    recommendedJobOpportunities?: JobOpportunityType[];
    recommendPost?: PostType;
    showLeft?: boolean;
    showTip?: boolean;
    showVoteCard?: boolean;
    showLocation?: boolean;
    locationSalary?: HotCitiesType;
    needTestCultural?: boolean;
    rate?: Record<string, number> | null;
    marketingEle?: React.ReactNode;
    marginTop?: string;
  }) => {
    return (
      <Grid className="tablet:flex">
        <div
          className={`hidden tablet:basis-1/3 tablet:w-1/3 tablet:grow-0 tablet:block tablet:pl-10 ${marginTop}`}
        >
          <Grid className="tablet:h-full tablet:w-full">
            {showVoteCard && (
              <VoteCard showVoteCard={showVoteCard} rate={rate} />
            )}
            {Array.isArray(recommendedJobOpportunities) &&
              recommendedJobOpportunities.length > 0 && (
                <div className="mb-7.5">
                  <p className="text-xl leading-7 font-semibold mb-4">
                    推荐职位
                  </p>
                  <JobOpportunityPanel
                    data={recommendedJobOpportunities}
                    chunkSize={4}
                    mobileChunkSize={4}
                    slideClassName="grid grid-cols-1 gap-y-2 tablet:grid-rows-3 tablet:grid-cols-1"
                    dataEleGroup="hot-job_recommend"
                  />
                </div>
              )}
            {recommendPost && (
              <div className="mb-7.5">
                <p className="text-xl leading-7 font-semibold mb-4">推荐文章</p>
                <Post data={recommendPost} dataObserverId="right" />
              </div>
            )}
            {showLocation && locationSalary && (
              <div className="mb-7.5">
                <CityCard data={locationSalary} />
              </div>
            )}
            {marketingEle}
          </Grid>
        </div>
        {showLeft && (
          <Grid className="order-first tablet:basis-2/3 tablet:w-2/3 tablet:grow-0">
            {content.map(
              ({ key, node, id }) =>
                node && (
                  <div
                    key={key}
                    id={id}
                    data-ele-id="content"
                    data-ele-group={key}
                    data-observer-id={key}
                  >
                    {node}
                  </div>
                ),
            )}
          </Grid>
        )}
      </Grid>
    );
  },
);

export default RenderTabs;
